import React, {useState} from 'react';
import Header from "../../../layouts/Header";

import {useParams} from "react-router-dom";
import {HiOutlineLocationMarker, HiOutlineQrcode} from "react-icons/hi";
import {BsCalendar4Week, BsInfo, BsInfoSquare} from "react-icons/bs";
import {TbCoin, TbStar, TbStatusChange} from "react-icons/tb";

import { CiPercent, CiViewList} from "react-icons/ci";
import {GiTwoCoins} from "react-icons/gi";
import {getOrder, storeRating, updateStatus} from "../api/OrdersAPI";
import Loading from "../../../layouts/Loading";
import {showError} from "../../../utils/toastHelper";
import RatingStars from "./RatingStars";
import StarRatingInput from "./StarRatingInput";


const currencyFormat = Intl.NumberFormat('en-US');

function Order() {
    const {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [order, setOrder] = React.useState([]);
    const [status, setStatus] = React.useState(6);
    const [rating, setRating] = React.useState(0);
    const [comment, setComment] = React.useState('');
    const config = window.APP_CONFIG;


    let totalPrice = 0;
    let totalDiscount = 0;
    let totalTax = 0;

    React.useEffect(() => {

        setLoading(true);
        const fetchOrder = async () => {

            try {
                const params = {

                }
                const data = await getOrder(id, params);
                setOrder(data.data);

            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchOrder();

    }, [id, status]);

    const onButtonClick = async () => {
        setLoading(true);
        const request = {
            order: id,
            status
        }
        await updateStatus(request);
        setStatus(0)

    }

    const onSetRating = async () => {

        setLoading(true);
        const other_rates = order.details.map((item) => ({
            id: item.product.id,
            rate: rating,
            type: 'Product',
            parent_id: null,
            related_id: id,
        }));

        const request = {
            id,
            rate: rating,
            type: 'Order',
            parent_id: null,
            comment,
            other_rates
        }
        await storeRating(request);

        window.location.reload()
    }


    if (loading) return <Loading/>;

    if (!order || Object.keys(order).length === 0) {
        return <div>سفارش یافت نشد</div>;
    }


    return (
        <React.Fragment>
            <Header title='جزییات سفارش' hasBack={true}/>
            <div className="modal fade bottom-sheet " id="rating" tabIndex="-1"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-bottom mobile-size-option">
                    <div className="modal-content">
                        <div className="modal-header rtl w-100 row">

                            <div className="col-8">
                                <h5 className="modal-title fs-6 fw-bold" id="exampleModalLabel">
                                    ثبت امتیاز برای سفارش
                                </h5>
                            </div>
                            <div className="col-4 text-start">
                                <button type="button" className="btn-close " data-bs-dismiss="modal"
                                        aria-label="Close"></button>
                            </div>


                        </div>
                        <div className="modal-body ">
                            <div className='mt-3'>
                                چه امتیازی به این سفارش خود می دهید؟
                            </div>
                            <div className='text-center mt-2 ltr'>
                                <StarRatingInput onChange={setRating}/>
                                <strong className='mt-2 fw-bold text-big-3'>{rating}</strong>
                            </div>
                            <div className='mt-4'>
                                نظر خود را راجع به محصولاتی که سفارش داده اید بنویسید:
                            </div>
                            <div className='text-cente mt-3'>
                                <textarea onChange={(event) => {
                                    setComment(event.target.value)
                                }}
                                          value={comment}
                                          className='w-100'
                                          rows={10}
                                ></textarea>
                            </div>

                            <div className='mt-3'>
                                <button className='btn bg-primary-color w-100 text-white'
                                onClick={onSetRating}
                                >
                                    ثبت امتیاز
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            {
                !loading &&
                <section className="container  mt-3 py-5 rtl px-0   ">
                    {
                        order.review ?
                            <div className="row mx-2 mb-5 bg-success-subtle py-2 border border-success rounded">

                                <div className="col-6 text-small-2 text-muted">
                                    امتیازی که دادید:
                                </div>
                                <div className="col-6 text-start fw-bold text-small-2 text-decoration-underline rtl">
                                    <RatingStars rating={order.review.rating} color='#117848'/>

                                </div>
                                <div className="col-12 mt-2 text-success text-small-2 text-center">
                                    {order.review.comment}
                                    <div className='mt-2 text-dark'>
                                        {order.review.reply}
                                    </div>
                                </div>
                            </div> :

                            order?.last_status?.type === 'Last' ?
                                <div className="row mx-2 mb-5 bg-warning-subtle py-2 border border-warning rounded">
                                    <div className="col-1">
                                        <TbStar/>
                                    </div>
                                    <div className="col-5 text-small-2">
                                        به این سفارش امتیاز دهید
                                    </div>
                                    <div className="col-6 text-start fw-bold text-small-2 text-decoration-underline "
                                         data-bs-toggle="modal"
                                         data-bs-target="#rating"
                                    >
                                        ثبت امتیاز
                                    </div>
                                </div> : ''
                    }
                    <div className="row mx-2 mb-3 border-bottom pb-2">
                        <div className="col-1">
                            <HiOutlineQrcode/>
                        </div>
                        <div className="col-5 text-small-2">
                            کد رهگیری:
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2">
                            {order.tracking_code}
                        </div>
                    </div>
                    <div className="row mx-2 mb-3 border-bottom pb-2">
                        <div className="col-1">
                            <TbStatusChange/>
                        </div>
                        <div className="col-5 text-small-2">
                            وضعیت سفارش
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2"
                             style={{color: order?.last_status?.color}}>
                            {order?.last_status?.title}
                        </div>
                        <div className="col-md-6 d-none d-md-block">
                            &nbsp;
                        </div>
                        {
                            order?.last_status.id === 1 ?

                                <div className="col-12 col-md-6 mt-3 text-center">
                                    <button className="btn btn-outline-danger text-small-2 w-100"
                                            onClick={onButtonClick}
                                    >
                                        لغو سفارش
                                    </button>
                                </div> : ''
                        }

                    </div>

                    <div className="row mx-2 mb-3  border-bottom pb-2">
                        <div className="col-1">
                            <BsCalendar4Week/>
                        </div>
                        <div className="col-4 text-small-2">
                            تاریخ ثبت
                        </div>
                        <div className="col-7 text-start fw-bold text-small-2">
                            {order.date}
                        </div>
                    </div>

                    <div className="row mx-2 mb-3  border-bottom pb-2">
                        <div className="col-1">
                            <BsInfoSquare/>
                        </div>
                        <div className="col-11 text-small-2">
                           توضیحات و ملاحضات
                        </div>
                        <div className="col-12 text-end me-3 fw-bold text-small-2">
                            {order.order_description}
                        </div>
                    </div>

                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1">
                            <HiOutlineLocationMarker/>
                        </div>
                        <div className={order.address?.lat ? "col-7 text-small-2 pt-1" : "col-11 text-small-2 pt-1"}>
                            {order?.address ?
                                <span className='fw-bold mt-2'>

                                    {order?.address?.title}
                                    :
                                    &nbsp;
                                    {order.address?.address}
                                </span>
                                :
                                <span className='fw-bold mt-2'>

                                    مراجعه حضوری
                                    :
                                    &nbsp;
                                    {config.address}
                                </span>
                            }

                        </div>
                        {
                            order.address?.lat &&
                        <div className="col-4 text-start fw-bold text-small-2 pt-1">
                            {order.address?.lat &&
                            <a href={`geo:${order.address?.lat},${order.address?.long}`} rel="noreferrer"
                               target='_blank'>مشاهده روی نقشه</a>
                            }
                        </div>
            }
                    </div>

                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1 mb-3">
                            <CiViewList/>
                        </div>
                        <div className="col-11 text-small-2 fw-bold pt-1 mb-3">
                            فاکتور
                        </div>

                        <div className="col-1 text-small-1 text-center border-bottom py-2">
                            #
                        </div>
                        <div className="col-6 text-small-1 text-center border-bottom py-2">
                            عنوان
                        </div>
                        <div className="col-3 text-small-1 text-center border-bottom py-2">
                            فی
                        </div>
                        <div className="col-2 text-small-1 text-center border-bottom py-2">
                            تعداد
                        </div>

                        {

                            order.details.map((detail, index) => {

                                totalPrice += parseInt(detail.price * detail.count);
                                if (detail.tax_percent) {
                                    let taxAmount = detail.tax_percent * detail.price / 100;
                                    totalTax += parseInt(taxAmount * detail.count);
                                }

                                if (detail.discount_percent) {
                                    let discountAmount = detail.discount_percent * detail.price / 100;
                                    totalDiscount += parseInt(discountAmount * detail.count);
                                }


                                return (
                                    <React.Fragment key={index}>
                                        <div className="col-1 text-small-1 text-center border-bottom py-2">
                                            {index + 1}
                                        </div>
                                        <div className="col-6 text-small-2 text-center border-bottom py-2 fw-bold">
                                            {detail.product.name}
                                            <span className='text-danger float-start'>{detail.sku} </span>
                                        </div>
                                        <div className="col-3 text-small-1 text-center border-bottom py-2">
                                            {currencyFormat.format(detail.price)}
                                        </div>
                                        <div className="col-2 text-small-1 text-center border-bottom py-2">
                                            {detail.count}
                                        </div>
                                    </React.Fragment>
                                )
                            })


                        }
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-3">
                            <TbCoin className='ms-2'/>
                            مبلغ فاکتور
                        </div>
                        <div className="col-5 fw-bold mt-3 text-secondary text-small-2  text-start">
                            {currencyFormat.format(totalPrice)}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-2 border-bottom pb-2">
                            <CiPercent className='ms-2'/>
                            تخفیف کالاها
                        </div>
                        <div className="col-5 fw-bold mt-3 text-success  border-bottom pb-2 text-start">
                            {currencyFormat.format(totalDiscount)}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-2 border-bottom pb-2">
                            <CiPercent className='ms-2'/>
                            سایر تخفیف ها
                        </div>
                        <div className="col-5 fw-bold mt-3 text-success  border-bottom pb-2 text-start">
                            {currencyFormat.format(order.discount)}
                            &nbsp;
                            ریال
                        </div>

                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-2 border-bottom pb-2">
                            <CiPercent className='ms-2'/>
                            مالیات
                        </div>
                        <div className="col-5 fw-bold mt-3 text-danger  border-bottom pb-2 text-start">
                            {currencyFormat.format(totalTax)}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>

                        <div className="col-5 mt-3 text-small-2">
                            <GiTwoCoins className='ms-2'/>
                            مبلغ قابل پرداخت:
                        </div>
                        <div className="col-5 fw-bold mt-3  text-start">
                            {currencyFormat.format(order.pay_amount * (1 - (order.cash_discount_percent / 100)))}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-2">
                            <GiTwoCoins className='ms-2'/>
                            مبلغ پرداخت شده:
                        </div>
                        <div className="col-5 fw-bold mt-3  text-start text-success">
                            {currencyFormat.format(order.payed_amount)}
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-2 mt-3">
                            &nbsp;
                        </div>
                        <div className="col-5 mt-3 text-small-2">
                            <GiTwoCoins className='ms-2'/>
                            مبلغ باقی مانده:
                        </div>
                        <div className="col-5 fw-bold mt-3  text-start text-warning">
                            {currencyFormat.format((order.pay_amount * (1 - (order.cash_discount_percent / 100))) - order.payed_amount)}
                            &nbsp;
                            ریال
                        </div>
                    </div>

                </section>
            }


        </React.Fragment>
    );
}

export default Order;